import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import EqualizerIcon from "@material-ui/icons/Equalizer";
import BusinessIcon from "@material-ui/icons/Business";
import SupervisedUserCircleIcon from "@material-ui/icons/SupervisedUserCircle";
import WorkIcon from "@material-ui/icons/Work";
import CardMembershipIcon from "@material-ui/icons/CardMembership";
import ReceiptIcon from "@material-ui/icons/Receipt";
import UpdateIcon from "@material-ui/icons/Update";
import ExploreIcon from "@material-ui/icons/Explore";
import AssessmentIcon from "@material-ui/icons/Assessment";
import GroupIcon from "@material-ui/icons/Group";
import AnnouncementIcon from "@material-ui/icons/Announcement";
import HealingIcon from "@material-ui/icons/Healing";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";
import PortraitIcon from "@material-ui/icons/Portrait";
import SettingsIcon from "@material-ui/icons/Settings";
// import { SidebarOptions } from "../@types/sidebarOptions.types";
import TextsmsIcon from "@material-ui/icons/Textsms";
import PublishIcon from "@material-ui/icons/Publish";
import RecentActorsIcon from "@material-ui/icons/RecentActors";
import { CiCalculator1 } from "react-icons/ci";
import { AiFillCalculator } from "react-icons/ai";
import { menuMappings } from "../../../constants/menuMappings";

// return type =const sidebarOptions: SidebarOptions = {
const test = {
	"SUPER ADMIN": [
		{
			caption: "Groups",
			route: "/",
			icon: () => <BusinessIcon />,
			subTabs: []
		},
		{
			caption: "Members",
			route: "/members",
			icon: () => <SupervisedUserCircleIcon />,
			subTabs: []
		},
		{
			caption: "Settings",
			route: "/",
			icon: () => <WorkIcon />,
			subTabs: [
				{
					caption: "User Management",
					route: "/settings/user-management",
					icon: () => <WorkIcon />,
					subTabs: []
				}
			]
		}
	]
};

const dynamicSidebarOptions = (role: any, userWithPermissions: any) => {
	// const accessesed: any = userWithPermissions.permissions.role_based_menu_view.menu_lists;
	// const role = userWithPermissions.role;
	// const permissions = userWithPermissions.permssions;
	// const role = "SUPER ADMIN";
	// const role = "EMPLOYER";
	const permissions = userWithPermissions;
	const accessesed: any = userWithPermissions.role_based_menu_view.menu_lists;

	// console.log("accessed", accessesed);

	const processedSidebarOptions: any = {
		[role]: []
	};

	const permissionsMenuKeysList = Object.keys(permissions); // keys in array

	for (let i = 0; i < permissionsMenuKeysList.length; i++) {
		const menuKey = permissionsMenuKeysList[i];

		// check for current menu is accessible or not by user
		if (permissions[menuKey].hasOwnProperty("self") && permissions[menuKey]["self"].view == true) {
			if (menuMappings.hasOwnProperty(menuKey)) {
				const sideBarMenu = menuMappings[menuKey];
				// if current menu is accessible then check for ,does it has sub menu if yes then check for if it is accessible

				sideBarMenu["subTabs"] = sideBarMenu["subTabs"].filter((subTab: any) => {
					const subMenu = sideBarMenu["subTabsMapping"][subTab.caption];
					if (permissions[menuKey]["self"].hasOwnProperty(subMenu)) {
						if (
							(permissions[menuKey]["self"][subMenu].hasOwnProperty("self") &&
								permissions[menuKey]["self"][subMenu]["self"].view == true) ||
							permissions[menuKey]["self"][subMenu].view == true
						) {
							return true;
						} else {
							return false;
						}
					} else {
						return false;
					}
				});

				// filter final access show sidebar as per menu lists based on role
				if (accessesed[role.toLowerCase().replaceAll(" ", "_")].includes(menuKey)) {
					processedSidebarOptions[role].push(sideBarMenu);
				}

				// Object.keys(permissions[menuKey]["self"]).forEach((subKey: any) => {
				// 	if (subKey.endsWith("_sub")) {
				// 		if (permissions[menuKey]["self"][subKey].view == true) {
				// 		}
				// 	}
				// });
			}
		} else if (permissions[menuKey]?.view == true) {
			if (menuMappings.hasOwnProperty(menuKey)) {
				const sideBarMenu = menuMappings[menuKey];
				// if current menu is accessible then check for ,does it has sub menu if yes then check for if it is accessible

				sideBarMenu["subTabs"] = sideBarMenu["subTabs"].filter((subTab: any) => {
					const subMenu = sideBarMenu["subTabsMapping"][subTab.caption];
					if (permissions[menuKey].hasOwnProperty(subMenu)) {
						if (
							(permissions[menuKey][subMenu].hasOwnProperty("self") &&
								permissions[menuKey][subMenu]["self"].view == true) ||
							permissions[menuKey][subMenu].view == true
						) {
							return true;
						} else {
							return false;
						}
					} else {
						return false;
					}
				});

				// filter final access show sidebar as per menu lists based on role
				if (accessesed[role.toLowerCase().replaceAll(" ", "_")].includes(menuKey)) {
					processedSidebarOptions[role].push(sideBarMenu);
				}

				// Object.keys(permissions[menuKey]["self"]).forEach((subKey: any) => {
				// 	if (subKey.endsWith("_sub")) {
				// 		if (permissions[menuKey]["self"][subKey].view == true) {
				// 		}
				// 	}
				// });
			}
		}
	}

	return processedSidebarOptions;
};

export default dynamicSidebarOptions;
